import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';

// Central dayjs configuration (replaces moment). Plugins cover the surface the
// app relied on:
// - advancedFormat: `Do` ordinal day tokens
// - customParseFormat: parsing with an explicit format, e.g. dayjs(t, 'HH:mm')
// - utc: dayjs.utc(...) / .utc()
// - isSameOrBefore / isSameOrAfter / isBetween: comparison helpers
// - duration: dayjs.duration(...)
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);

export default dayjs;
